import { ref } from 'vue'
import type { AdminServiceSwitchingType } from '@/entities/Cabinet'

/**
 * Модель для mqtt
 */
export const useModelMqtt = () => {
  const data = ref<{ topic_type: string; topic: string; message: string | number }>({
    topic_type: 'custom',
    topic: '',
    message: '',
  })

  const messageTypes = [
    'custom',
    'at_commands',
    'file_list',
    'system_log',
    'rs-485',
    'get_settings',
    'offline',
    'delta',
    'change_broker',
  ]

  const logTypes: { title: number; value: string }[] = [
    { title: 1, value: 'indigo.log.0' },
    { title: 2, value: 'indigo.log.1' },
  ]

  return {
    data,
    messageTypes,
    logTypes,
  }
}

/**
 * Модель для настроек правил переключения
 */
export const useModelSwitching = () => {
  const data = ref<AdminServiceSwitchingType[]>([])

  /**
   * Функция удаления правила из массива
   * @param index
   */
  const deleteSwitch = (index: number) => {
    data.value.splice(index, 1)
  }

  /**
   * Функция добавления нового правила
   */
  const addSwitch = () => {
    data.value.push({
      Inputs: [],
      Outputs: [],
      TimeON: 1,
    })
  }

  return {
    data,

    deleteSwitch,
    addSwitch,
  }
}
